import {
  ExcludedProduct,
  ExpiryModeType,
  LoyaltySpecFormType,
} from 'api/loyalty-domain/loyalty-domain.type';
import * as yup from 'yup';

// @ts-expect-error
export const loyaltySpecSchema: yup.SchemaOf<LoyaltySpecFormType> = yup.object({
  allowReturnsAfterConfirmationPeriod: yup.boolean(),
  awardPointsAsPending: yup.boolean(),
  awardPointsForGiftCardTransaction: yup
    .boolean()
    .default(true)
    .nullable(true)
    .transform(val => (val === null ? true : val)),
  confirmationPeriod: yup.number().min(0).max(365).default(0).required(),
  expiryPeriod: yup.number().when('expiryMode', {
    is: val => val === 'SinceCurrentTx',
    then: schema => schema.required().min(1).default(365),
    otherwise: schema => schema.default(0),
  }),
  expiryMode: yup
    .mixed<ExpiryModeType>()
    .oneOf(['NoExpiry', 'SinceCurrentTx'])
    .required()
    .default('NoExpiry'),
  defaultPointsAwardRatio: yup.number().required().min(0).default(0),
  dynamicPointsAwardRatioEnabled: yup.boolean().default(false),
  dynamicPointsAwardRatio: yup.array().when('dynamicPointsAwardRatioEnabled', {
    is: true,
    then: schema => schema.min(1),
  }),
  excludedProducts: yup.array<ExcludedProduct>().required().default([]),
});
